'use client';

export const getOS = () => {
  if (typeof window === 'undefined') {
    return 'server-side';
  }

  return (
    (window.navigator.userAgent ||
      window.navigator.vendor ||
      //@ts-ignore
      window.opera) as string
  ).toLowerCase();
};

export const isAndroid = getOS().includes('android');
export const isIOS = ['ipad', 'iphone', 'ipod'].some((ios) => getOS().includes(ios));
export const isWindowPhone = getOS().includes('windows phone');
export const isDesktop = !isAndroid && !isIOS && !isWindowPhone;
export const isTouchDevice = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.matchMedia('(pointer: coarse)').matches;
};
